<template>
  <nav class="sb-topnav navbar navbar-expand navbar-light this-topnav">
    <slot name="application-name"></slot>
    <slot name="toggle-button"></slot>
    <slot name="navbar-menu-left"></slot>
    <slot name="navbar-search"></slot>
    <slot name="navbar-free-slot"></slot>
    <slot name="navbar-menu-right"></slot>
  </nav>
</template>
<script>
export default {
  name: "TopNav",

  /** mixins **/
  mixins: [],

  /** props **/
  props: {},

  /** data **/
  data() {
    return {}
  },

  /** methods**/
  methods: {},

  /**  computed  **/
  computed: {},

  /** mounted **/
  mounted() {
  },

  /** created **/
  created() {
  },

  /** watch
   searchText : {
			handler : 'fetchUserList',
			immediate : true,
		}
   **/
  watch: {},

  /** destroyed **/
  destroyed() {
  },
}
</script>

<style scoped>
.this-topnav{
  background-color : #D44946 !important;
}
</style>
